export function printRank(value: number) {
  const lastChar = String(value).substring(-1);
  if (lastChar === '1') return `${value}st`;
  if (lastChar === '2') return `${value}nd`;
  if (lastChar === '2') return `${value}rd`;
  return `${value}th`;
}
